module.exports = __webpack_public_path__ + "img/drone_01_H.621e1ee7.webp";